import React,{ forwardRef } from 'react';
import { Box, CircularProgress, SxProps, Theme } from '@mui/material';

interface LoadingStateProps {
    size?: number | string;
    sx?: SxProps<Theme>;
}

export const LoadingState = forwardRef<HTMLDivElement, LoadingStateProps>(
    ({ size = 40, sx }, ref) => {
        return (
            <Box
                ref={ref}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    py: 4,
                    ...sx,
                }}
            >
                <CircularProgress size={size} />
            </Box>
        );
    }
);

LoadingState.displayName = 'LoadingState';
